import Body from './Body'
import Footer from './Footer'
import Header from './Header'

export { Body, Footer, Header }
